<style>
#map {
	height: 100%;
	width: 100%;
	max-height: 100%;
	max-width: 100%;
	z-index: 1;
	margin-right: 0px;
	position: relative;
}

.map-info {
	position: absolute;
	padding: 5px;
	border-radius: 10px;
	top: 10px;
	right: 10px;
	z-index: 1000;
	background-color: rgba(255, 255, 255, 0.85);
	color: black;
	box-shadow: 0px 0px 5px lightgrey;
	font-size: 14px;
}

@media (max-width:972px) {
	#map {
		min-height: 33vh;
		max-height: 33vh;
		width: 100vw;
		user-select: none;
		margin: 0px;
		border-bottom: 1px solid rgb(223, 223, 223);
	}

	.map-info {
		font-size: 12px;
		max-width: 65vw;
	}
}
</style>

<link rel="stylesheet" href="https://unpkg.com/leaflet@1.6.0/dist/leaflet.css" integrity="sha512-xwE/Az9zrjBIphAcBb3F6JVqxf46+CDLwfLMHloNu6KEQCAWi6HcDUbeOfBIptF7tcCzusKFjFw2yuvEpDL9wQ==" crossorigin=""/>

<script>
import {push,pop,replace} from './pt-router/Router.svelte'
import L from 'leaflet';
import { onMount } from 'svelte';
import * as Common from './Common.js'

export let items;
export let requestNewItems;
export let setNewItemLocation;
export let newItemType = 0;
export let bounds;
export let enableSelection;
export let forcedRefreshPending = false

export let hilightedItems = null

let ready = false;
let lruCache; // Common.LeafletLRU

let map;
let selectedMarker;
let requestInProgress = false;

$: enableSelection || function() {
	if(!ready) {
		return
	}
	if(selectedMarker != undefined) {
		map.removeLayer(selectedMarker)
	}
}()

$: forcedRefreshPending && function() {
	if(!ready) {
		return
	}
	handleMapMove()
	forcedRefreshPending = false
}()

function setCorrectMarkerOpacity(item) {
	let myGroup = L.layerGroup([item.marker])
	if(!hilightedItems) {
		myGroup.eachLayer(function(layer) {
			layer.setOpacity(1.0);
		});
	} else if(hilightedItems.find(e => e==item.item.id)) {
		myGroup.eachLayer(function(layer) {
			layer.setOpacity(1.0);
		});
	} else {
		myGroup.eachLayer(function(layer) {
			layer.setOpacity(0.3);
		});
	}
}

$ : updateHilightedItems = function(hilightedItems) {
	if(!ready) {
		return;
	}

	for(let i in hilightedItems) {
		let cachedItem = lruCache.get(hilightedItems[i])
		if(!cachedItem) {
			continue
		}
		setCorrectMarkerOpacity(cachedItem)
	}
	if(lruCache) {
		lruCache.cache.forEach(e => {
			setCorrectMarkerOpacity(e)
		})
	}
	
}(hilightedItems)

$ : updateItems = function (items) {
	if(!ready) {
		return
	}
	for(let i in items) {
		let item = items[i]
		let cachedItem = lruCache.get(item.id)
		if(cachedItem) {
			setCorrectMarkerOpacity(cachedItem)
			continue
		}

		var newIcon = getIconFromType(item.type)
		var marker = L.marker([item.latitude, item.longitude],{icon: newIcon}).addTo(map);

		lruCache.set(item.id, {item: item, marker: marker})
		setCorrectMarkerOpacity(lruCache.get(item.id))

		marker.id = item.id

		if (Common.isMobile()) {
			createMobilePopup(marker)
		} else {
			marker.on('click', handleMarkerClick);
		}
		
		if(false /*item.type >= 1000 && !Common.isMobile()*/) {

			let munItemType = `
			<div style="
				color: white;
				background-color: black;
				border-radius: 10px;
				padding: 5px;
				margin-right: 10px;
				min-width: 100px;
				text-align: center;
			">
			&#x2714;` + Common.getItemTypeString(item.type) + `</div>`


			let tooltipContent = `
				<div style="display: flex;">
					<div style="padding-top: 5px; flex:1;">` + munItemType+ `</div>
					<div style="padding-left: 5px;"><strong>` + item.title + `</strong></div>
				</div>
				`;


			let popup =
			L.popup({closeButton: false, autoClose: false, closeOnClick: false})
			.setContent(tooltipContent);
			marker.bindPopup(popup, {padding: 0}).openPopup()
		} else {
			if(!Common.isMobile()) {
				marker.on('mouseover', handleMarkerMouseover);
				marker.on('mouseout', handleMarkerMouseout);
			}
		}
	}
	requestInProgress = false;
}(items)

$: bounds && refreshBounds()

$: (newItemType != null) && updateMarkerColor()

function refreshBounds() {
	if(!ready) {
		return
	}
	if(bounds) {
		map.setView([bounds.lat, bounds.lng], bounds.zoom)
	}
}

onMount(async () => {
	L.Popup.include({
	_updatePosition() {
		var e = {originalEvent: this._lastEvent};
			
		this.fire('predrag', e);

		var pos = this._map.latLngToLayerPoint(this._latlng),
		    offset = L.point(this.options.offset),
		    anchor = this._getAnchor();

		if (this._zoomAnimated) {
			L.DomUtil.setPosition(this._container, !L.Browser.retina ? pos.add(anchor).round() : pos.add(anchor));
		} else {
			offset = offset.add(pos).add(anchor);
		}

		var bottom = this._containerBottom = -offset.y,
		    left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;

		// bottom position the popup in case the height of the popup changes (images loading etc)
		this._container.style.bottom = bottom + 'px';
		this._container.style.left = left + 'px';

				// @event predrag: Event
				// Fired continuously during dragging *before* each corresponding
				// update of the element's position.
				//L.DomUtil.setPosition(this._element, !L.Browser.retina ? this._newPos.round() : this._newPos);

				// @event drag: Event
				// Fired continuously during dragging.
				this.fire('drag', e);
		}
	})


	let osmUrl;
	let tileSize;
	let zoomOffset;
	
	if(false) {
		osmUrl='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
		tileSize=256
		zoomOffset=0
	} else {
		osmUrl = 'https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png'
		tileSize=256
		zoomOffset=0
	}
	
	let osmAttrib = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
	let osm = L.tileLayer(osmUrl, {maxZoom: 18, attribution: osmAttrib, tileSize: tileSize, zoomOffset: zoomOffset})

	map = L.map('map').addLayer(osm)
	map.on('click', handleMapClick)
	map.on('moveend', handleMapMove)
	
	lruCache = new Common.LeafletLRU(/*cacheSize*/ 200, /*evictFunc*/ (data) => {
		map.removeLayer(data.marker)
	})
	
	window.onresize = () => {
		if(!ready) {
			return
		}
		map.invalidateSize(true)
	}

	attemptSetBounds()
});

function attemptSetBounds() {
	if(!bounds) {
		setTimeout(attemptSetBounds, 50);
		return
	}
	ready = true
	map.setView([bounds.lat, bounds.lng], bounds.zoom)
	refreshBounds()
}


function getMunItemName(type) {
	switch(type) {
		case Common.ITEMTYPE_ANNOUNCEMENT:
			return 'Announcement';
		case Common.ITEMTYPE_QUESTION:
			return 'Question';
		case Common.ITEMTYPE_NOTICE:
			return 'Notice';
	}
}

function updateMarkerColor() {
	if(selectedMarker == undefined) {
		return
	}

	map.removeLayer(selectedMarker)
	let leafletLocation = selectedMarker.getLatLng();

	let loc = {
		item_latitude : leafletLocation.lat,
		item_longitude : leafletLocation.lng,
	}

	var newIcon = getIconFromType(newItemType)
	selectedMarker = L.marker([loc.item_latitude, loc.item_longitude],{icon: newIcon}).addTo(map);
	selectedMarker.id = 0
	setNewItemLocation(loc)
}

function handleMapClick(e) {
	if(!enableSelection) {
		return
	}

	let loc = {
		item_latitude : e.latlng.lat,
		item_longitude : e.latlng.lng,
	}

	var newIcon = getIconFromType(newItemType)

	if(selectedMarker != undefined) {
		map.removeLayer(selectedMarker)
	}

	selectedMarker = L.marker([loc.item_latitude, loc.item_longitude],{icon: newIcon}).addTo(map);
	selectedMarker.id = 0
	setNewItemLocation(loc)
}

function handleMapMove() {
	if(requestInProgress) {
		return;
	}
	if(!ready) {
		return
	}

	requestInProgress = true;
	let newBounds = map.getBounds()
	let req = {
		first : {
			latitude: newBounds._northEast.lat,
			longitude: newBounds._northEast.lng
		},
		second : {
			latitude: newBounds._southWest.lat,
			longitude: newBounds._southWest.lng
		},
		exclude: {}
	}

	map.eachLayer( function(layer) {
		if(layer instanceof L.Marker) {
		if(map.getBounds().contains(layer.getLatLng())) {
			req.exclude[layer.id] = 1;
		}
		}
	});
	requestNewItems(req)
}

function handleMarkerClick(e) {
	push('/item/' + e.target.id)
}

function createMobilePopup(marker) {
	let item = lruCache.get(marker.id).item;
	let likes = `<span style="
		color: white;
		background-color: ` +((item.type >= 1000) ? "rgb(0, 0, 0)" : "rgb(70, 70, 70)") +`;
		padding: 5px;
		margin: 0px;
		margin-right:10px;
		font-size: 10px;
		border-radius: 5px;">` + ((item.type >= 1000) ?  Common.getItemTypeString(item.type) : (item.likes)) + `</span>`

	let content = `
	<div style="display: flex;">
		<div>` + likes+ `</div>
		<div style="word-wrap: anywhere;"><strong>` + item.title + `</strong></div>
	</div>
	`;
	let tooltipContent = L.DomUtil.create('div')
	tooltipContent.innerHTML = content

	let popup =
		L.popup({closeButton: false, autoClose: false, closeOnClick: true})
		.setContent(tooltipContent);
	marker.bindPopup(popup, {padding: 0})
	tooltipContent.onclick = () => {
		map.closePopup();
		push('/item/' + item.id)
	}
}

function handleMarkerMouseover(e) {
	let item = lruCache.get(e.target.id).item;

	let likes = null
	if(item.type >= 1000) {
		likes = `<div style="flex:1; background-color: black; padding: 5px; margin-right: 10px; font-size: 10px; border-radius: 5px; color: white; text-align: center">` + ((item.type >= 1000) ? Common.getItemTypeString(item.type) : (item.likes))+ `</div>`
	} else {
		likes = `<div><span style="
		color: white;
		background-color: rgb(70, 70, 70);
		padding: 5px;
		margin: 0px;
		margin-right:10px;
		font-size: 10px;
		border-radius: 5px;">` + item.likes + `</span></div>`
	}


	let tooltipContent = `
	<div style="display: flex;">`
		+ likes + `
		<div style="word-wrap: anywhere;"><strong>` + item.title + `</strong></div>
	</div>
	`;

	let popup =
		L.popup({closeButton: false, autoClose: false, closeOnClick: false})
		.setContent(tooltipContent);
	e.target.bindPopup(popup, {padding: 0}).openPopup();
	popup._container.childNodes[0].onclick = () => {
		push('/item/' + item.id)
	}
}

function handleMarkerMouseout(e) {
	e.target.closePopup()
}

function getIconFromType(type) {
	let options = {
		shadowUrl: '/marker_img/marker-shadow.png',
		iconSize: [48,48],
		iconAnchor: [24,48],
		tooltipAnchor: [0.5, -32],
		shadowSize: [41,41],
		shadowAnchor: [12,41],
		popupAnchor: [0.5, -32]
	}

	if(type == Common.ITEMTYPE_NEWS) {
		options.iconUrl = '/marker_img/marker-icon-news.png';
		options.iconRetinaUrl = '/marker_img/marker-icon-news-retina.png'
	} else if (type == Common.ITEMTYPE_SUGGESTION) {
		options.iconUrl = '/marker_img/marker-icon-suggestion.png';
		options.iconRetinaUrl = '/marker_img/marker-icon-suggestion-retina.png'
	} else if (type == Common.ITEMTYPE_PRAISE) {
		options.iconUrl = '/marker_img/marker-icon-praise.png';
		options.iconRetinaUrl = '/marker_img/marker-icon-praise-retina.png'
	} else if (type == Common.ITEMTYPE_CRITICISM) {
		options.iconUrl = '/marker_img/marker-icon-critisicm.png';
		options.iconRetinaUrl = '/marker_img/marker-icon-critisicm-retina.png'
	} else if (type == Common.ITEMTYPE_MISC) {
		options.iconUrl = '/marker_img/marker-icon-misc.png';
		options.iconRetinaUrl = '/marker_img/marker-icon-misc-retina.png'
	} else {
		options.iconUrl = '/marker_img/marker-icon-municipal.png'
		options.iconRetinaUrl = '/marker_img/marker-icon-municipal-retina.png'
	}
	
	return L.icon(options);
}
</script>

<div id="map"></div>
